import { track, trackException, trackPV } from "@jupiter/core";
import { getGlobalObject } from "@jupiter/utils";
import * as BrowserIntegrations from "./integrations";
import { init } from "./sdk";

const Jupiter = {
  Integrations: {
    ...BrowserIntegrations,
  },
  track,
  trackException,
  trackPV,
  init,
};

try {
  getGlobalObject()["Jupiter"] = Jupiter;
} catch (e) {
  console.log("failed to bind Jupiter to global", e);
}

export default Jupiter;
